import * as React from 'react';
import { Row } from 'src/design-system/box/Box';
import { Link } from 'src/design-system/link/link';
import { Image } from '@utmb/design-system/image/Image';
import { Font } from 'src/design-system/text/font';
import styles from '../../table.module.scss';
import { pIdToCloudinary } from '@utmb/utils/cloudinary';

interface CellButtonProps {
    cell: any;
    otherData: any;
}

export const CellButton = (props: CellButtonProps) => {
    const { cell, otherData } = props;

    return (
        <Link
            href={
                cell.column.Header == 'Itinerary'
                    ? `https://www.openstreetmap.org/search?query=${cell.value}#map=17`
                    : cell.column.Header == 'Performance'
                    ? `/races-runners/runners/rankings/${cell.value}`
                    : ''
            }
            className={styles.table_button_link}
        >
            <div className={styles.table_button_v1}>
                <Row className={styles.table_button_v1_content}>
                    <Image
                        width="15"
                        height="15"
                        image={
                            cell.column.Header == 'Itinerary'
                                ? pIdToCloudinary('/assets/icon-pin', 'pin')
                                : cell.column.Header == 'Performance'
                                ? pIdToCloudinary('/assets/icon-arrowbtn', 'arrow')
                                : pIdToCloudinary('/assets/icon-arrowbtn', 'arrow')
                        }
                    />
                    <Font.FuturaBold mobile="10" desktop="10" className={styles.table_button_v1_label}>
                        {otherData
                            ? otherData.itineraryButtonLabel
                                ? otherData.itineraryButtonLabel
                                : otherData.performanceButtonLabel
                                ? otherData.performanceButtonLabel
                                : '[NO LABEL]'
                            : '[NO LABEL]'}
                    </Font.FuturaBold>
                </Row>
            </div>
        </Link>
    );
};
